import { jwtDecode } from 'jwt-decode';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReferralCode } from '../../hooks/useReferralCode';

// When user open's the referral link, need to redirect to home page or login
const ReferralLink: React.FC = () => {
  const navigate = useNavigate();
  const { extractCodeFromUrl } = useReferralCode();

  function isTokenValid(token: string | null): boolean {
    if (!token) return false;
    try {
      const decoded = jwtDecode(token);
      if (!decoded || !decoded.exp) return false;
      return decoded.exp * 1000 > Date.now();
    } catch {
      return false;
    }
  }

  useEffect(() => {
    console.log('-- refer link component effect ');

    // Extract and store referral code
    extractCodeFromUrl();

    // Navigate based on auth status
    const token = localStorage.getItem('token');
    if (isTokenValid(token)) {
      navigate('/');
    } else {
      navigate('/login');
    }
  }, [navigate, extractCodeFromUrl]);

  return <div>Loading..</div>;
};

export default ReferralLink;
